import React, { useState } from "react";
// @material-ui/core components
import classNames from "classnames";

import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
import People from "@material-ui/icons/People";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Alert from "@material-ui/lab/Alert";
import backgroundImage from "assets/img/blur_bg.jpg";

import styles from "assets/jss/nextjs-material-kit/pages/loginPage.js";
import customStyles from "assets/jss/custom/customStyles.js";
import { Typography } from "@material-ui/core";
import { useRouter } from "next/router";

const useStyles = makeStyles({
  ...styles,
  ...customStyles,
});

export default function ResetPage(props) {
  const router = useRouter();
  
  const [email, setEmail] = useState("");
  const [linkSent, setLinkSent] = useState(false);
  const classes = useStyles();
  const { ...rest } = props;

  async function handleSubmit(event) {
    event.preventDefault();
    const url = "/api/reset";

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (response.status === 200) {
        setLinkSent(true);
      } else {
        console.log("Login failed.");
        // https://github.com/developit/unfetch#caveats
        let error = new Error(response.statusText);
        error.response = response;
        throw error;
      }
    } catch (error) {
      console.error(
        "You have an error in your code or there are Network issues.",
        error
      );
    }
  }

  return (
    <div>
      <Header fixed color="primary" {...rest} />
      <div
        className={classNames(classes.rowGrey)}
        style={{ backgroundImage: "url(" + backgroundImage.src + ")" }}
      >
        <div
          className={classNames(classes.container, classes.hasPaddingTop)}
          style={{ paddingTop: "6em", paddingBottom: "3em" }}
        >
          <GridContainer justify="center" className={classes.hasPaddingTop}>
            <GridItem xs={12} sm={9} md={7} lg={5}>
              <div className={classes.signUpBox}>
                <form className={classes.form} onSubmit={handleSubmit}>
                  <h4
                    className={classNames(
                      classes.isBold,
                      classes.hasTextCentered
                    )}
                    style={{ marginBottom: 0, marginTop: "1em" }}
                  >
                    Passwort zurücksetzen
                  </h4>
                  {linkSent && (<>
                    <Alert severity="success">
                      Wenn deine E-Mail bekannt ist, erhältst du in Kürze einen
                      Link zum Zurücksetzen des Passworts. Bitte schaue ggf.
                      auch in deinem Spam Ordner. Der Link ist 24 Stunden
                      gültig.
                    </Alert>
                    <Button color="primary" fullWidth onClick={() => {
                        router.push("/");
                      }}
                    >
                      Zur Startseite
                    </Button>
                  </>)}
                  {!linkSent && 
                  <>
                    <Typography variant="body1" style={{ paddingTop: "1rem" }}>
                      Gib bitte deine hinterlegte E-Mail-Adresse ein und klicke
                      auf "Link zusenden". Wir senden dir im Anschluss einen Link
                      per Mail, mit dem du dein Passwort erneuern kannst.
                    </Typography>

                    <CustomInput
                      labelText="E-Mail"
                      id="email"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "email",
                        endAdornment: (
                          <InputAdornment position="end">
                            <Email className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                        onChange: (event) => setEmail(event.target.value),
                        value: email,
                      }}
                    />
                    <Button color="primary" fullWidth type="submit">
                      Link zusenden
                    </Button>
                  </>}
                </form>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </div>
      <Footer />
    </div>
  );
}
